import React from "react";

import { FieldProps } from "formik";
import cx from "clsx";

export interface InputProps extends FieldProps {
  label?: string;
  placeholder?: string;
  htmlType?: string;
  type?: string;
  disabled?: boolean;
}

export default ({
  label,
  placeholder,
  htmlType = "text",
  type = "text",
  disabled,
  field,
  form,
  ...rest
}: InputProps) => {
  const touched = form.touched[field.name];
  const error = form.errors[field.name];

  const inputClasses = cx("form-control", {
    "is-invalid": touched && error,
    "is-valid": touched && !error,
    disabled
  });
  const feedbackClasses = cx({
    "invalid-feedback": touched && error,
    "valid-feedback": touched && !error
  });

  const renderComponent = (props: object = {}) => {
    switch (htmlType) {
      case "textarea":
        return <textarea {...props} {...field} />;
      default:
        return <input {...props} {...field} />;
    }
  };

  return (
    <div className="form-group">
      {label && <label className="control-label">{label}</label>}
      {renderComponent({ type, className: inputClasses, placeholder, disabled, ...rest })}
      {touched && error && <div className={feedbackClasses}>{error}</div>}
    </div>
  );
};
